import * as actions from './actions'
import type { NotificationPreference, Action } from './type'

export type State = {
  preferences: NotificationPreference[];
  errors: any[];
  savingEmailPreferences: boolean;
};

const initialState = {
  preferences: [],
  errors: [],
  savingEmailPreferences: false,
  savedEmailPreferences: false
} as const

const reducer = (state: State, action: Action) => {
// @ts-expect-error - TS2322 - Type '{ readonly preferences: readonly []; readonly errors: readonly []; readonly savingEmailPreferences: false; readonly savedEmailPreferences: false; }' is not assignable to type 'State'.
  if (state === undefined) { state = initialState }
  switch (action.type) {
// @ts-expect-error - TS2678 - Type '"API_EMAIL_PREFERENCES_SHOW_SUCCESS"' is not comparable to type '"API_EMAIL_PREFERENCES_SHOW"'. - fall through
    case actions.FETCH_NOTIFICATION_PREFERENCE_SUCCESS:
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'Action'. - fall through
      const { data: { preferences } } = action

      return {
        ...state,
        preferences
      }
// @ts-expect-error - TS2678 - Type '"API_EMAIL_PREFERENCES_UPDATE"' is not comparable to type '"API_EMAIL_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_NOTIFICATION_PREFERENCE:
      return {
        ...state,
        savingEmailPreferences: true,
        savedEmailPreferences: false
      }
// @ts-expect-error - TS2678 - Type '"API_EMAIL_PREFERENCES_UPDATE_SUCCESS"' is not comparable to type '"API_EMAIL_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_NOTIFICATION_PREFERENCE_SUCCESS:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'data' does not exist on type 'Action'. - fall through
        preferences: action.data.preferences,
        savingEmailPreferences: false,
        savedEmailPreferences: true
      }
// @ts-expect-error - TS2678 - Type '"API_EMAIL_PREFERENCES_UPDATE_FAILURE"' is not comparable to type '"API_EMAIL_PREFERENCES_SHOW"'. - fall through
    case actions.SAVE_NOTIFICATION_PREFERENCE_FAILURE:
// @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Action'. - fall through
      return { ...state, errors: action.errors }
// @ts-expect-error - TS2678 - Type '"UPDATE_NOTIFICATION_PREFERENCE"' is not comparable to type '"API_EMAIL_PREFERENCES_SHOW"'. - fall through
    case actions.UPDATE_NOTIFICATION_PREFERENCE:
      return {
        ...state,
// @ts-expect-error - TS2339 - Property 'preferences' does not exist on type 'Action'. - fall through
        preferences: action.preferences,
        savedEmailPreferences: false
      }
    default:
      return state
  }
}

export default reducer
